// extracted by mini-css-extract-plugin
module.exports = {"container":"thankYou_container___wsvT","wrapper":"thankYou_wrapper__301D_"};